/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.repopulateCart(cart);
        console.log("jsCart change js")
       
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  generateLineItemHTML: function (item, lineNumber) {
    let priceInCents = item.final_price * item.quantity;
    let priceInCentsOld = 0
    if(item.compare_at_price > 0){
      priceInCentsOld =item.compare_at_price * item.quantity
    }
    return `
  <div class="ajax-cart__product media" 
       data-product-id="${item.product_id}" 
       data-variant-price-full="${item.final_price}" 
       data-variant-allocation="" 
       data-variant-id="${item.variant_id}" 
       data-cart-item="${item.key}" 
       data-line-item="${lineNumber}">
    
    <figure class="ajax-cart__product-image media-left">
      <a href="${item.url}">
        <img src="${item.image}" alt="${item.title} - cart preview">
      </a>
      <div class="ajax-cart__quantity-box product-quantity-box mobile_quantity" data-key="${item.key}" data-line-item-key="${lineNumber}">
        <label class="label is-sr-only" for="quantity">Qty</label>
        <div class="quantity-wrapper field has-addons quantity-style--box is-medium">
          <div class="control minus-control">
            <span class="quantity-minus quantity-element button" data-update-quantity="minus" ${
              item.quantity <= 1 ? "disabled" : ""
            }>
              <span class="icon" data-icon="minus">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                  <g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g>
                </svg>
              </span>
            </span>
          </div>
          <div class="control quantity-input-control quantity-input-control--fill">
            <input class="quantity-input quantity-element input" 
                   type="number" 
                   min="1" 
                   size="2" 
                   name="quantity" 
                   value="${item.quantity}" 
                   data-line-id="${lineNumber}">
          </div>
          <div class="control plus-control">
            <span class="quantity-plus quantity-element button" data-update-quantity="plus">
              <span class="icon" data-icon="plus">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                  <g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g>
                </svg>
              </span>
            </span>
          </div>
        </div>
      </div>
    </figure>

    <div class="ajax-cart__product-content media-content">
      <div class="ajax-cart__product-title">
        <a href="${item.url}">
          ${item.product_title}
        </a>
      </div>
     ${
        item.selling_plan_allocation?.selling_plan
          ? `<p class="ajax-cart__selling-plan-name">${item.selling_plan_allocation.selling_plan.name}</p>`
          : ""
      }
        <div class="ajax-cart__product-variant" data-variant-id="${item.variant_id}">
            ${item.variant_title ? item.variant_title : ""}        
        </div>
      <div class="ajax-cart__price price">
        <span class="money sale">${Shopify.formatMoney(
          priceInCents
        )}</span>
        ${item.compare_at_price ? `<span class="money compare-at-price">${Shopify.formatMoney(priceInCentsOld)}</span>`: ""}
      </div>

      <div class="ajax-cart__quantity-box product-quantity-box desktop_quantity" data-key="${item.key}" data-line-item-key="${lineNumber}">
        <label class="label is-sr-only" for="quantity">Qty</label>
        <div class="quantity-wrapper field has-addons quantity-style--box is-medium">
          <div class="control minus-control">
            <span class="quantity-minus quantity-element button" data-update-quantity="minus" ${
              item.quantity <= 1 ? "disabled" : ""
            }>
              <span class="icon" data-icon="minus">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                  <g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g>
                </svg>
              </span>
            </span>
          </div>
          <div class="control quantity-input-control quantity-input-control--fill">
            <input class="quantity-input quantity-element input" 
                   type="number" 
                   min="1" 
                   size="2" 
                   name="quantity" 
                   value="${item.quantity}" 
                   data-line-id="${lineNumber}">
          </div>
          <div class="control plus-control">
            <span class="quantity-plus quantity-element button" data-update-quantity="plus">
              <span class="icon" data-icon="plus">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                  <g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g>
                </svg>
              </span>
            </span>
          </div>
        </div>
        <div class="ajax-cart-remove">
          <a class="ajax-cart__delete" data-ajax-cart-delete="" data-cart-item-key="${
            item.key
          }" href="/cart/change?line=${lineNumber}&quantity=0" title="Remove">
            <button class="close" aria-label="close">Remove</button>
          </a>
        </div>
      </div>
    </div>
  </div>
`;
  },
  repopulateCart: function (cart) {
  console.log("jsCart repopulate")
    if (cart.item_count > 0) {
      // Update the cart list and details using the cart object
      const cartItemsHtml = cart.items
        .map((item, index) => Shopify.theme.jsCart.generateLineItemHTML(item, index))
        .join("");
      $(".ajax-cart__list").html(cartItemsHtml);

      // Show/hide appropriate elements
      $(".ajax-cart__empty-cart-message").addClass("is-hidden");
      $(".ajax-cart__form").removeClass("is-hidden");
      $("[data-ajax-cart-trigger]").addClass("has-cart-count");
      $('[data-bind="itemCount"]').text(cart.item_count);

      // Update the shipping indicator asynchronously
      
      if ($("[data-fs-threshold]").length) {
        const $parent = $("[data-fs-threshold]");
        const $remainingWrapper = $parent.find(".fs-indicator__remaining");
        const $successWrapper = $parent.find(".fs-indicator__success");

        const fsThreshold = $parent.data("fs-threshold");
        const totalPrice = cart.total_price;

        if (fsThreshold >= totalPrice) {
          const fsRemaining = fsThreshold - totalPrice;
          const fsRemainingPercent = (totalPrice / fsThreshold) * 100;

          $remainingWrapper
            .find(".bar")
            .css("width", `${fsRemainingPercent}%`);
          $remainingWrapper
            .find('[data-bind="remaining-amount"]')
            .text(Shopify.formatMoney(fsRemaining));

          $remainingWrapper.removeClass("is-hidden");
          $successWrapper.addClass("is-hidden");
        } else {
          $remainingWrapper.addClass("is-hidden");
          $successWrapper.removeClass("is-hidden");
        }
      }
    } else {
      // Handle empty cart view
      $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
      $(".ajax-cart__form").addClass("is-hidden");
      $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
      $('[data-bind="itemCount"]').text(0);
    }
    this.showUpsell();
  },
  updateView: function (cart, lineID) {
  
    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;